import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!
  const _component_CancelPolicyContent = _resolveComponent("CancelPolicyContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      キャンセルポリシー・注意点\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CancelPolicyContent, null, {
      default: _withCtx(() => [
        _createVNode(_component_OrderFixedButton, {
          hasSub: "",
          enabledVariant: "primary",
          onClick: _ctx.onClickLastConfirm,
          abTestGroup3300: _ctx.abTestGroup3300
        }, {
          sub: _withCtx(() => [
            _createTextVNode("\n          ボタンを押すと上記内容を同意することになります\n        ")
          ]),
          default: _withCtx(() => [
            _createTextVNode("\n        最終確認へ\n        ")
          ], undefined, true),
          _: 1
        }, 8, ["onClick", "abTestGroup3300"])
      ], undefined, true),
      _: 1
    })
  ]))
}